import { Button, Col, Drawer, Row } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import AlertItem from '../alert-item';
import { AlertFormPreviewSC } from './alerts-form.styled';

type TProps = {
  method: 'HILBI' | 'SMS' | 'EMAIL';
  text: string;
  loading: boolean;
  onConfirm(): void;
  onBack: () => void;
  doctorName: string | void;
};

const AlertFormPreview: React.FC<TProps> = ({
  method,
  text,
  loading,
  onConfirm,
  doctorName,
  onBack,
}) => {
  return (
    <AlertFormPreviewSC>
      <Drawer.Title></Drawer.Title>
      <div className="afp-body">
        <p className="doc-name">
          <b>{doctorName ? doctorName : null}</b>
        </p>
        <AlertItem method={method} isSent={false} text={text} />
      </div>
      <Row gutter={[16, 0]}>
        <Col>
          <Button variant="ghost" leftArrow onClick={onBack} block={false}>
            <FormattedMessage id="vital_history.back" />
          </Button>
        </Col>
        <Col>
          <Button variant="primary" onClick={onConfirm} loading={loading}>
            <FormattedMessage id="alerts.form_sent" />
          </Button>
        </Col>
      </Row>
    </AlertFormPreviewSC>
  );
};

export default AlertFormPreview;
